import(/* webpackMode: "eager" */ "/tmp/px-build-1793654850/src/app/error.js")